import { render, staticRenderFns } from "./CRDropdown.vue?vue&type=template&id=463970b7&scoped=true"
import script from "./CRDropdown.vue?vue&type=script&lang=js"
export * from "./CRDropdown.vue?vue&type=script&lang=js"
import style0 from "./CRDropdown.vue?vue&type=style&index=0&id=463970b7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "463970b7",
  null
  
)

export default component.exports